import React, { useState, } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, List, ListItem, ListItemText, Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import axios from 'axios';
import { uploadImages } from './action/action';
import { arabicTextExtraction } from './action/arabicApi';
import { SnackbarProvider, enqueueSnackbar } from 'notistack'
import { Menu, } from "@mui/material";
import {
    Wrapper,
    StyledTable,
    DropZone,
    StyledList,
    AttachementWrapper,
    TableWrapper,
    FileDetailWrapper,
    FileNameTypography,
    RefreshWrapper,
    StyleMenu,
    RadioButtonWrapper,
    LabelWrapper
} from './HomePageStyle';
import LinearProgress from '@mui/material/LinearProgress';


const MeterTable = () => {
    const [fileList, setFileList] = useState([]); // State to store the files
    const [fileNames, setFileNames] = useState([]); // State to store the file names
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [isDragging, setIsDragging] = useState(false);
    const [selectedImage, setSelectedImage] = useState({
        pdf_url: "",
        txt_url: "",
        word_url: "",
        file_name: "",
        file_type: "",
        // file_name: ""
    })
    const [selectedOption, setSelectedOption] = useState("Meter Reading")
    const [isOpen, setIsOpen] = useState(false)
    const [popoverOpen, setPopoverOpen] = useState("");
    const open = Boolean(popoverOpen);
    const id = open ? "simple-popover" : undefined;



    // Update file list and file names when files are selected
    const handleFileChange = (e) => {
        const files = [...e.target.files];
        setFileList(files);
        setFileNames(files.map(file => file.name)); // Save file names
    };

    // Function to handle file attachment
    const handleAttachFiles = async () => {

        if (fileList.length === 0) {
            enqueueSnackbar("Please select a file before uploading.", { variant: "warning" });
            return; // Exit if no files are selected
        }

        setIsLoading(true)
        const formData = new FormData();
        fileList.forEach((file, index) => {
            formData.append(`files`, file);
        });

        // if (selectedOption === "Meter Reading") {
        //     const response = await uploadImages(formData)
        //     setIsLoading(false)
        //     if (response.status) {
        //         setTableData(response?.data);
        //     }
        //     else {
        //         enqueueSnackbar(response.error, { variant: "error" });
        //     }
        //     setFileList([]);
        //     setFileNames([]); // Clear file names after uploading
        //     setIsDragging(false);
        // }

        // else {

        const response = await arabicTextExtraction(formData)
        setIsLoading(false)
        if (response.status) {
            setTableData(response?.data);
        }
        else {
            enqueueSnackbar(response.error, { variant: "error" });
        }
        setFileList([]);
        setFileNames([]); // Clear file names after uploading
        setIsDragging(false);
        // }

    };

    // Handle drag over event
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    // Handle drag leave event
    const handleDragLeave = () => {
        setIsDragging(false);
    };

    // Handle drop event
    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const files = [...e.dataTransfer.files];
        setFileList(files);
        setFileNames(files.map(file => file.name)); // Save file names
    };

    const handleOnRefresh = () => {
        setTableData([])
        // setSelectedImage("")
        // setFileList([])
    }

    const handleOpenImage = (url, file_type, file_name) => {

        setSelectedImage({ ...selectedImage, file_type: file_type })
        setIsOpen(true)
    }


    const handleClose = () => {
        setIsOpen(false)
        // setSelectedImage('')
    }

    const handleClick = (e) => {
        setPopoverOpen(e.currentTarget);
    };
    const handleCloseDrawer = () => {
        setPopoverOpen(null);
    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    // const downloadFile = (link, fileName, fileType) => {
    //     console.log("linkkkkk", link)
    //     const element = document.createElement("a");
    //     element.href = link;
    //     element.target = "_blank";
    //     element.download = link;
    //     element.click();
    // };

    const downloadFile = async (link, fileName, file_type) => {

        // for downloading word file directly
        if (file_type === "word") {
            const element = document.createElement("a");
            element.href = link;
            element.target = "_blank";
            element.download = link;
            element.click();
        }
        // for download pdf and txt file by opening save as dailogue box
        else {
            try {
                const response = await fetch(link);
                const blob = await response.blob();

                const element = document.createElement("a");
                const blobUrl = window.URL.createObjectURL(blob);
                element.href = blobUrl;
                element.setAttribute("download", link);

                // Append to the document and trigger the download
                document.body.appendChild(element);
                element.click();

                // Clean up after the download
                document.body.removeChild(element);
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error("Download failed:", error);
            }
        }

    };


    return (
        <Wrapper>
            <AttachementWrapper>
                {/* DropZone component for drag-and-drop area */}
                <DropZone
                    className={isDragging ? 'dragover' : ''}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="fileInput"
                    />
                    <label htmlFor="fileInput" style={{ cursor: 'pointer', display: 'block', marginTop: '10px' }}>
                        Browse or Drag and drop files here
                    </label>
                </DropZone>

                {/* List of selected files */}
                {fileList.length > 0 && (
                    <StyledList>
                        {Array.from(fileList).map((file, index) => (
                            <FileDetailWrapper key={index} > {/* Adjust width as needed */}
                                <FileNameTypography>
                                    {file.name}
                                </FileNameTypography>
                            </FileDetailWrapper>
                        ))}
                    </StyledList>
                )}

                <SnackbarProvider />

                {/* Button to attach files */}
                <div style={{
                    height: "10%", marginTop: '20px', display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Button onClick={handleAttachFiles} color="primary" variant="contained">
                        Attach Files
                    </Button>
                </div>

            </AttachementWrapper>

            {/* <RadioButtonWrapper>
                <div>
                    <h3>Select an option:</h3>
                </div>
                <LabelWrapper>
                    <label>
                        <input
                            type="radio"
                            value="Meter Reading"
                            checked={selectedOption === 'Meter Reading'}
                            onChange={handleOptionChange}
                        />
                        Meter Reading
                    </label>

                    <label>
                        <input
                            type="radio"
                            value="Arabic Text"
                            checked={selectedOption === 'Arabic Text'}
                            onChange={handleOptionChange}
                        />
                        Arabic Text Extractor
                    </label>
                </LabelWrapper>
            </RadioButtonWrapper> */}

            {/* Table to display meter data */}
            <TableWrapper style={{ width: "100%", }}>
                <div>

                    {isLoading && (
                        <div style={{ width: "25%", marginTop: "30px", marginLeft: "35%" }}>
                            <LinearProgress />
                        </div>
                    )}
                    <RefreshWrapper style={{ marginLeft: "80%" }} onClick={() => handleOnRefresh()} />
                </div>


                <TableContainer component={Paper} style={{ marginTop: '30px', width: "70%", marginLeft: "15%", marginBottom: "30px" }}>
                    <StyledTable>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ backgroundColor: "#1976d2", color: "white" }}>Sr. No.</TableCell>
                                <TableCell style={{ backgroundColor: "#1976d2", color: "white" }}>Image Name</TableCell>
                                <TableCell style={{ backgroundColor: "#1976d2", color: "white" }}>Parse Status</TableCell>
                                {/* {selectedOption === "Meter Reading" && (
                                    <>
                                        <TableCell style={{ backgroundColor: "#1976d2", color: "white" }}>Upload Status</TableCell>
                                        <TableCell style={{ backgroundColor: "#1976d2", color: "white" }}>Meter Reading</TableCell>
                                        <TableCell style={{ backgroundColor: "#1976d2", color: "white" }}>Power Unit</TableCell>
                                    </>
                                )} */}

                            </TableRow>
                        </TableHead>
                        {/* { table data for genus ocr} */}
                        {/* {selectedOption === "Meter Reading" && (
                            <TableBody>
                                {tableData?.parsed_uploaded_files && (tableData?.parsed_uploaded_files.map((row, index) => (
                                    <TableRow key={row.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell sx={{ display: "flex", gap: "10px", }}>
                                            {row.url ? (
                                                <div onClick={() => {
                                                    // handleOpenImage(row.url, "image")
                                                }} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                                    {row.filename}
                                                </div>
                                            ) : (
                                                'No Image'
                                            )}
                                        </TableCell>
                                        <TableCell >Done</TableCell>
                                        <TableCell>{row?.
                                            parse_status}</TableCell>
                                        <TableCell>{row.
                                            electricity_reading}</TableCell>
                                        <TableCell>{row.electricity_unit}</TableCell>
                                    </TableRow>
                                )))}
                            </TableBody>
                        )} */}

                        {/* {table body for arabic text} */}

                        <TableBody>
                            {tableData?.response && (tableData?.response.map((row, index) => (
                                <TableRow key={row.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell sx={{ display: "flex", gap: "10px", }}>
                                        {row.file_name ? (
                                            <div
                                                style={{ cursor: 'pointer', }}>
                                                {row.file_name}
                                            </div>
                                        ) : (
                                            'No Image'
                                        )}
                                        <Button color="primary" variant="contained" onClick={(e) => {
                                            setSelectedImage({
                                                pdf_url: row.pdf_url,
                                                word_url: row.word_url,
                                                txt_url: row.txt_url,
                                                file_name: row.file_name
                                            })
                                            handleClick(e)
                                        }}
                                            style={{
                                                backgroundColor: "#1A73E8",
                                                border: "2px solid #0D47A1",
                                                color: "#FFFFFF",
                                                height: "22px",
                                                padding: "8px 16px",
                                                fontFamily: "Roboto, Arial, sans-serif"
                                            }}
                                            onMouseOver={(e) => e.target.style.backgroundColor = '#63A4FF'}
                                            onMouseOut={(e) => e.target.style.backgroundColor = '#1A73E8'}
                                        >Save as</Button>

                                    </TableCell>
                                    <TableCell >Done</TableCell>
                                </TableRow>
                            )))}
                        </TableBody>


                        <Menu
                            id={id}
                            open={open}
                            anchorEl={popoverOpen}
                            onClose={handleCloseDrawer}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "left", // Align the menu to the right
                            }}
                            transformOrigin={{
                                vertical: "bottom",
                                horizontal: "left", // Change this to "left" to ensure it opens towards the right
                            }}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    overflow: "visible",
                                    filter: "drop-shadow(0px 8px 24px rgba(0, 0, 0, 0.15))", // softer shadow
                                    width: "150px", // slightly wider for more comfortable text space
                                    mb: "10px",
                                    ml: "50px",
                                    borderRadius: "12px",
                                    border: "1px solid #E8EAF6", // soft border for structure
                                    backgroundColor: "#FFFFFF", // plain background
                                    "& .MuiAvatar-root": {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1,
                                    },
                                    "&:before": {
                                        content: '""',
                                        display: "block",
                                        position: "absolute",
                                        // top: 0,
                                        left: 15,
                                        bottom: -10, // Position the arrow above the menu
                                        // left: 15, // Adjust horizontal position if needed
                                        width: 12,
                                        height: 12,
                                        bgcolor: "#FFFFFF",
                                        transform: "translateY(-50%) rotate(45deg)",
                                        zIndex: 0,
                                    },
                                    "& ul.MuiMenu-list": {
                                        padding: 0,
                                        overflow: "hidden",
                                    },
                                    "& ul.MuiMenu-list > li:not(:last-child)": {
                                        borderBottom: "1px solid #F0F0F0", // lighter border between items
                                    },
                                    "& ul.MuiMenu-list > li": {
                                        padding: "12px 16px", // consistent padding for items
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        transition: "background-color 0.2s ease", // smooth hover effect
                                        "&:hover": {
                                            backgroundColor: "#F5F7FF", // light hover color
                                        },
                                    },
                                    "& ul.MuiMenu-list > li:first-child": {
                                        borderRadius: "12px 12px 0px 0px",
                                    },
                                    "& ul.MuiMenu-list > li:last-child": {
                                        borderRadius: "0px 0px 12px 12px",
                                    },
                                },
                            }}
                        >
                            <>
                                <StyleMenu
                                    onClick={() => handleOpenImage(selectedImage.pdf_url, "pdf")}>
                                    {/* Optionally add an icon next to the text */}
                                    Save as pdf
                                </StyleMenu>
                                <StyleMenu onClick={() => handleOpenImage(selectedImage.txt_url, "txt")}>
                                    Save as txt
                                </StyleMenu>
                                <StyleMenu onClick={() => handleOpenImage(selectedImage.word_url, "word")}>
                                    Save as docx
                                </StyleMenu>
                            </>
                        </Menu>

                        <Modal open={isOpen} onClose={handleClose}>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    bgcolor: 'background.paper',
                                    boxShadow: 24,
                                    p: 2,
                                    outline: 'none',
                                    width: '80%', // Adjust width for better visibility
                                }}
                            >


                                {/* {selectedImage.file_type === 'image' && (

                                    <img src={selectedImage.url} alt="Selected" style={{ width: '100%', height: '600px' }} />
                                )} */}

                                {selectedImage.file_type === 'pdf' && (
                                    <div>
                                        {selectedImage.file_name}
                                        <iframe
                                            src={selectedImage.pdf_url}
                                            title="PDF Viewer"
                                            style={{ width: '100%', height: '600px' }}
                                        />
                                    </div>

                                )}

                                {selectedImage.file_type === 'word' || selectedImage.file_type === 'docx' ? (
                                    <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedImage.word_url)}`}
                                        height="530px" width="100%" title="Word Document Viewer"></iframe>
                                ) : null}

                                {selectedImage.file_type === 'txt' && (
                                    <iframe
                                        src={selectedImage.txt_url}
                                        title="PDF Viewer"
                                        style={{ width: '100%', height: '600px' }}
                                    />
                                )}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{ mt: 2 }}
                                    onClick={(e) => {
                                        if (selectedImage.file_type === "pdf") {
                                            downloadFile(selectedImage.pdf_url, selectedImage.file_name, selectedImage.file_type,)
                                        }
                                        if (selectedImage.file_type === "word") {
                                            downloadFile(selectedImage.word_url, selectedImage.file_name, selectedImage.file_type,)
                                        }
                                        if (selectedImage.file_type === "txt") {
                                            downloadFile(selectedImage.txt_url, selectedImage.file_name, selectedImage.file_type,)
                                        }

                                    }}

                                >
                                    Download File
                                </Button>



                                <IconButton
                                    onClick={handleClose}
                                    sx={{ position: 'absolute', top: -30, right: 0, color: "white" }}
                                >
                                    <CloseIcon color='#1976d2' />
                                </IconButton>
                            </Box>
                        </Modal>
                    </StyledTable>
                </TableContainer>
            </TableWrapper>

        </Wrapper>

    );
};

export default MeterTable;

